module.exports = "/images/radiological-hazard@3x.png?8f17fa61f8caffbc5e927544bb8a627b";